import * as Yup from 'yup';
export var notificationSubTypeUpdateValidationSchema = Yup.object().shape({
    description: Yup.string().trim().min(1).max(512, 'Слишком длинное описание, максимум 512 символов').optional(),
    defaultTemplateId: Yup.string().optional(),
    templateIds: Yup.array().of(Yup.string()).optional()
});
